const DEFAULT_APP_BASE_URL = "https://app.cooperly.ai";
const LOCAL_DEVELOPMENT_APP_BASE_URL = "http://localhost";
const MARKETING_HOSTS = new Set(["cooperly.ai", "www.cooperly.ai"]);

export function getCooperlyAppBaseUrl() {
  const configured = process.env.NEXT_PUBLIC_APP_URL?.trim();
  const normalizedConfigured = normalizeConfiguredAppBaseUrl(configured);

  if (normalizedConfigured) {
    return normalizedConfigured;
  }

  return process.env.NODE_ENV === "development"
    ? LOCAL_DEVELOPMENT_APP_BASE_URL
    : DEFAULT_APP_BASE_URL;
}

function normalizeConfiguredAppBaseUrl(configured: string | undefined) {
  if (!configured) {
    return null;
  }

  const trimmed = configured.replace(/\/+$/, "");

  if (pointsAtMarketingSite(trimmed)) {
    return DEFAULT_APP_BASE_URL;
  }

  return trimmed;
}

function pointsAtMarketingSite(value: string) {
  try {
    return MARKETING_HOSTS.has(new URL(value).hostname.toLowerCase());
  } catch {
    const bareHost = value.replace(/^\/\//, "").split("/")[0]?.toLowerCase();

    return MARKETING_HOSTS.has(bareHost);
  }
}
